<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Smart Protect -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{$t('bp.ConfirmDamage.title')}}</h1>
                        </div>
                    </div>

                    <div class="col-12">
                        <p>
                            {{$t('bp.ConfirmDamage.message')}}
                        </p>

                        <div class="form-group" v-if="displayBackGlass">
                            <label> {{$t('bp.ConfirmDamage.backGlass')}} </label>
                            <div class="card-grid grid-col-2 row">
                                <div class="selectable-card horizontal"
                                     @click="selectBackGlassDamage('damaged')"
                                     :class="{'active': selectedBackGlassDamage === 'damaged'}">
                                    <div class="card-body mb-0 justify-content-center d-flex">
                                        <p>
                                           {{$t('bp.ConfirmDamage.damaged')}}
                                        </p>
                                    </div>
                                </div>
                                <div class="selectable-card horizontal"
                                     @click="selectBackGlassDamage('not-damaged')"
                                     :class="{'active': selectedBackGlassDamage === 'not-damaged'}">
                                    <div class="card-body mb-0 justify-content-center d-flex">
                                        <p>
                                          {{$t('bp.ConfirmDamage.notDamaged')}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group" v-if="displayFrame">
                            <label> {{$t('bp.ConfirmDamage.frame')}}</label>
                            <div class="card-grid grid-col-2 row">
                                <div class="selectable-card horizontal"
                                     @click="selectFrameDamage('damaged')"
                                     :class="{'active': selectedFrameDamage === 'damaged'}">
                                    <div class="card-body">
                                        <p>
                                          {{$t('bp.ConfirmDamage.damaged')}}
                                        </p>
                                    </div>
                                </div>
                                <div class="selectable-card horizontal"
                                     @click="selectFrameDamage('not-damaged')"
                                     :class="{'active': selectedFrameDamage === 'not-damaged'}">
                                    <div class="card-body">
                                        <p>
                                          {{$t('bp.ConfirmDamage.notDamaged')}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link :to="{ name: previousStep}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> {{$t('bp.backButton')}}</router-link>
                    <router-link :to="{ name: 'basket'}" class="btn btn-lg continue-btn icon-right ml-auto" :class="{'disabled': (askBackGlass && !selectedBackGlassDamage) || (askFrame && !selectedFrameDamage)}">{{$t('bp.nextButton')}} <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "ConfirmDamage",

        data() {
            return {
                displayBackGlass: false,
                displayFrame: false,
                selectedBackGlassDamage: false,
                selectedFrameDamage: false,
            }
        },

        mounted() {
            this.checkBookingIsComplete().then(() => {
                if (!this.askBackGlass && !this.askFrame) {
                    this.$router.push({name: 'basket'});
                }
                if (this.askBackGlass && !this.backGlassProblem) {
                    this.$router.push({name: 'basket'});
                    return;
                }
                if (this.askFrame && !this.frameProblem) {
                    this.$router.push({name: 'basket'});
                    return;
                }
                if (this.askBackGlass && this.backGlassProblem) {
                    this.displayBackGlass = true;
                }
                if (this.askFrame && this.frameProblem) {
                    this.displayFrame = true;
                }
            });
        },

        computed: {
            ...mapGetters([
                'askBackGlass',
                'askFrame',
                'backGlassProblem',
                'displayUpsellOptions',
                'frameProblem',
                'problems',
                'selectedProblems'
            ]),

            previousStep() {
                if (this.displayUpsellOptions) return 'extras';

                return 'repairSelect';
            },
        },

        methods: {
            ...mapActions([
                'checkBookingIsComplete',
                'toggleProblem',
                'toggleSymptom',
                'setBasketButtonOnConfirmDamagePage'
            ]),

            problemIsSelected(problem) {
                for (let i = 0; i < this.selectedProblems.length; i++) {
                    if (this.selectedProblems[i].id === problem.id) {
                        return true;
                    }
                }
                return false;
            },

            selectBackGlassDamage(option) {
                let problemIsSelected = this.problemIsSelected(this.backGlassProblem);

                if (
                    option === 'damaged' && !problemIsSelected ||
                    option === 'not-damaged' && problemIsSelected
                ) {
                    this.toggleProblem(this.backGlassProblem).then(() => {
                        if (option === 'damaged' && !problemIsSelected && this.backGlassProblem.symptoms.length > 0) {
                            this.toggleSymptom({problem: this.backGlassProblem, symptom: this.backGlassProblem.symptoms[0]});
                        }
                    });
                }

                this.selectedBackGlassDamage = option;
            },

            selectFrameDamage(option) {
                let problemIsSelected = this.problemIsSelected(this.frameProblem);

                if (
                    option === 'damaged' && !problemIsSelected ||
                    option === 'not-damaged' && problemIsSelected
                ) {
                    this.toggleProblem(this.frameProblem).then(() => {
                        if (option === 'damaged' && !problemIsSelected && this.frameProblem.symptoms.length > 0) {
                            this.toggleSymptom({problem: this.frameProblem, symptom: this.frameProblem.symptoms[0]});
                        }
                    });
                }

                this.selectedFrameDamage = option;
            }
        },

        watch: {
            selectedBackGlassDamage() {
                this.setBasketButtonOnConfirmDamagePage(false);
            },
            selectedFrameDamage() {
                this.setBasketButtonOnConfirmDamagePage(false);
            }
        }
    }
</script>

<style scoped>

</style>